
import data from './data'
import methods from './methods'
import mounted from './mounted'
import computed from './computed'
import components from './components'

export default {
  data,
  methods,
  mounted,
  computed,
  components
}



// WEBPACK FOOTER //
// ./src/app/tenant/profile/me/components/overview/components/feed/resources/index.js